import { CONTENT_MODE_TAB } from "Areas/Sidebar/Documents/constants";
import { getActiveDocument, getActiveDocumentId, getActiveDocumentType } from "Areas/Sidebar/Documents/redux/getActiveDocumentId";
import { getContentModeTab } from "Areas/Sidebar/Documents/redux/selectors";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import reject from "lodash/reject";
import { createSelector } from "reselect";
import { getContentMasterNodes } from "../../content/redux/selectors";
import { getUserContentFolders } from "../../contentUpload/redux/selectors";
import { getSourceData as getGraphData } from "../../graph/redux/selectors";
import { getSourceData as getMapData } from "../../map/redux/selectors";
import { getAvailableDocumentObjectIds, getColumns } from "../../table/redux/selectors";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import { READ_ONLY_MODE } from "../types/readOnlyMode";
export const getReadOnlyMode = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].readOnlyMode[${getActiveDocumentId(state)}]`), (readOnlyMode) => readOnlyMode || READ_ONLY_MODE.AUTO);
const documentDataIsEmptyMap = {
    [DOCUMENT_TYPE.GRAPH]: (state) => {
        const data = getGraphData(state);
        return data ? isEmpty(data.NodesSource) : undefined;
    },
    [DOCUMENT_TYPE.TABLE]: (state) => {
        var _a;
        const initialDocumentType = (_a = getActiveDocument(state)) === null || _a === void 0 ? void 0 : _a.Type;
        const data = initialDocumentType === DOCUMENT_TYPE.TABLE
            ? getColumns(state)
            : getAvailableDocumentObjectIds(state);
        return data ? data.length === 0 : undefined;
    },
    [DOCUMENT_TYPE.MAP]: (state) => {
        const data = getMapData(state);
        return data ? isEmpty(data.Points) && isEmpty(data.Geometry) : undefined;
    },
    [DOCUMENT_TYPE.CONTENT]: (state) => {
        const contentMode = getContentModeTab(state);
        if (contentMode === CONTENT_MODE_TAB.FOUND) {
            const data = getContentMasterNodes(state);
            return data ? isEmpty(data) : undefined;
        }
        const data = getUserContentFolders(state);
        return data ? isEmpty(reject(data, "Deleted")) : undefined;
    }
};
export const getFinalReadOnlyMode = createSelector((state) => getReadOnlyMode(state), (state) => {
    const type = getActiveDocumentType(state);
    if (!type || !documentDataIsEmptyMap[type])
        return undefined;
    return documentDataIsEmptyMap[type](state);
}, (readOnlyMode, documentDataIsEmpty) => {
    if (readOnlyMode !== READ_ONLY_MODE.AUTO)
        return readOnlyMode;
    if (documentDataIsEmpty === undefined)
        return READ_ONLY_MODE.AUTO;
    return documentDataIsEmpty ? READ_ONLY_MODE.READ_WRITE : READ_ONLY_MODE.READ_ONLY;
});
